import React from 'react';
import { IonModal } from '@ionic/react';

// Modals
import { SuccessModal, ErrorModal } from '../modals';

export const MobileContactMessageComponent = ({ state, history, pageConfig, setState, handleFinish }) => {

    return (
        <>
            <IonModal isOpen={state.showModal}>

                {state.status &&
                    <SuccessModal
                        message="¡Tu mensaje fue enviado con éxito!"
                        urlImage="assets/images/success.png"
                        title="Status Operación"
                        textButton="Volver al inicio"
                        history={history}
                        handleFinish={() => handleFinish(pageConfig.redirectToSuccess)}
                        closeModal={() => { setState({ ...state, showModal: false }) }} />
                }

                {!state.status &&
                    <ErrorModal
                        message="No se ha podido enviar tu mensaje."
                        urlImage="assets/images/error.png"
                        title="Status Transacción"
                        textButton="Intentar de Nuevo"
                        subtitle={<span className="text-error">Ha ocurrido un error.</span>}
                        history={history}
                        handleFinish={() => handleFinish(pageConfig.redirectToError)}
                        closeModal={() => { setState({ ...state, showModal: false }) }} />
                }
            </IonModal>
        </>
    )
}
